export default process.env.VUE_APP_TYPE === 'LOGISTICS' || process.env.IS_ELECTRON
